import { useState } from 'react';
import './App.css';

function App() {
  const samples = Array.from(Array(100).keys())
  const [startIdx, setStartIdx] = useState(0)
  return (
    <div className="App">
      <header>
        <h1>Audio Samples</h1>
        Audio samples from LibriTTS
      </header>
      <div className="container">
        Choose a range:&nbsp;
        <select onChange={(e) => {
          setStartIdx(e.target.value)
        }}>
          {samples.map(idx => <option value={idx}>{idx * 10} - {idx * 10 + 9}</option>)}
        </select>
        <table class="table">
          <thead>
            <tr>
              <td>Sample</td>
              <td>Source</td>
              <td>Target</td>
              <td>Adain-VC</td>
              <td>Ours (Same)</td>
              <td>Ours (Diff + Cycle + Speaker)</td>
            </tr>
          </thead>
          <tbody>
            {
              Array.from(Array(10).keys()).map(idx => {
                const fn = ("00" + (startIdx * 10 + idx)).slice(-3)
                return (<tr>
                  <td>Sample {startIdx + idx}</td>
                  <td><audio style={{ width: 220 }} src={process.env.PUBLIC_URL + `/audio/libritts/src/s${fn}.wav`} controls></audio></td>
                  <td><audio style={{ width: 220 }} src={process.env.PUBLIC_URL + `/audio/libritts/tgt/t${fn}.wav`} controls></audio></td>
                  <td><audio style={{ width: 220 }} src={process.env.PUBLIC_URL + `/audio/libritts/adainvc/c${fn}.wav`} controls></audio></td>
                  <td><audio style={{ width: 220 }} src={process.env.PUBLIC_URL + `/audio/libritts/same-part/c${fn}.wav`} controls></audio></td>
                  <td><audio style={{ width: 220 }} src={process.env.PUBLIC_URL + `/audio/libritts/diff-part-cycle-clf/c${fn}.wav`} controls></audio></td>
                </tr>)
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App;
